import React from "react";
import { Overlay } from "@blueprintjs/core";
import Wait from "../shared/Wait";

interface IProps {
  isBusy: boolean;
  message: string;
}

const LoginBusyIndicator: React.FC<IProps> = ({ isBusy, message, children }) => (
  <div style={{ position: "relative" }}>
    {children}
    <Overlay
      isOpen={isBusy}
      enforceFocus={false}
      autoFocus={false}
      transitionDuration={0}
      backdropProps={{ style: { backgroundColor: "rgba(255,255,255,0.5)" } }}
    >
      <div style={{
        position: "fixed", inset: 0, display: "flex",
        alignItems: "center", justifyContent: "center"
      }}>
        <Wait rightOrBottomText={message} />
      </div>
    </Overlay>
  </div>
);

export default LoginBusyIndicator;
